export default __webpack_public_path__ + "static/media/shady-b.e904028c.jpeg";